import Axios from 'axios'

export default {
  send_bw_cloud_os_quota_request(config, data) {
    return Axios.post('/api/bwcloud_os_quota', data, ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config)
  },
  send_bcd_request(config, data) {
    return Axios.post('/api/bcd_request', data, ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config)
  },
  send_vpn_vlan_request(config, data) {
    return Axios.post('/api/vpn_vlan_request', data, ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config)
  },
  send_wifi_vlan_request(config, data) {
    return Axios.post('/api/wifi_vlan_request', data, ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config)
  },
  send_vm_request(config, data) {
    return Axios.post('/api/vmware_vm_request', data, ('netdb_axios_config' in (config || {})) ? config.netdb_axios_config : config)
  }
}
